import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Component that automatically scrolls to top and manages focus when route changes
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Use requestAnimationFrame to ensure scroll happens after render
        requestAnimationFrame(() => {
            // Scroll to top when pathname changes
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

            // Focus management for accessibility
            const mainContent = document.getElementById('main-content');
            if (mainContent) {
                // Set tabIndex to -1 to make it programmatically focusable (without adding it to tab order)
                mainContent.setAttribute('tabindex', '-1');
                // Focus the main content WITHOUT scrolling (preventScroll: true)
                mainContent.focus({ preventScroll: true });
                // Remove tabIndex after focusing to keep it out of natural tab order
                mainContent.removeAttribute('tabindex');
            }
        });
    }, [pathname]);

    return null; // This component doesn't render anything
}

export default ScrollToTop;